import { render, staticRenderFns } from "./Cabecera.vue?vue&type=template&id=2bdf4d3e&scoped=true&"
import script from "./Cabecera.vue?vue&type=script&lang=js&"
export * from "./Cabecera.vue?vue&type=script&lang=js&"
import style0 from "./Cabecera.vue?vue&type=style&index=0&id=2bdf4d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf4d3e",
  null
  
)

export default component.exports